import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { CreditProcessStatus, CreditStatus } from 'src/app/@core/constants';
import { ColumnTable } from 'src/app/models/column-table';
import { CreditRequest } from 'src/app/models/credit-request';
import { Customer } from 'src/app/models/customer';
import { Filter } from 'src/app/models/filter';
import { Paging } from 'src/app/models/page';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'pos-credit-requests-in-process',
  templateUrl: './credit-requests-in-process.component.html',
  styleUrls: ['./credit-requests-in-process.component.sass']
})
export class CreditRequestsInProcessComponent implements OnInit, OnChanges {

  @Input()
  customer: Customer = new Customer();

  @Output()
  getAmountOfRequests = new EventEmitter<number>();

  creditRequests: Paging<Array<CreditRequest>> = new Paging([]);
  constructor(private onbaseService: OnbaseService, private configService: ConfigurationService) { }

  async ngOnInit(): Promise<void> {
  }

  async updateCreditRequests(filter: Filter<any>) {
    if (this.customer.code) {
      this.creditRequests = (await this.onbaseService.getRequests(this.customer.code, true, undefined, filter.page, filter.pageSize).toPromise()).response;
    }
    this.getAmountOfRequests.emit(this.creditRequests.totalElements);
  }

  async ngOnChanges(): Promise<void> {
    await this.updateCreditRequests({ page: 0, pageSize: 10, value: {} });
  }

  getCreditRequestHeaders(): Array<ColumnTable> {
    return [
      new ColumnTable("code", "Código de Solicitud"),
      new ColumnTable("requestData.Empresa", "Sociedad"),
      new ColumnTable("requestData.Division", "Sucursal"),
      new ColumnTable("requestData.Identificacion", "Identidad"),
      new ColumnTable("requestData.Nombre", "Nombre Cliente"),
      new ColumnTable("requestData.Tramite", "Plan de Crédito"),
      new ColumnTable("requestData.Fecha", "Fecha", { type: "date" }),
      new ColumnTable("status.0", "Estado", { type: "badge", valueMap: this.getBadgeStatusMap() }),
      new ColumnTable("processingStatus", "Estado del Proceso", { type: "badge", valueMap: this.getBadgeCreditProcessStatusMap() }),
      new ColumnTable("seller.fullname", "Nombre del Vendedor"),
    ];
  }

  getBadgeStatusMap(): Map<string, string> {
    let result = new Map<string, string>();

    result.set(CreditStatus.NO_STATUS, "Sin estado");
    result.set(CreditStatus.CONTROL_TABLE, "Mesa de Control");
    result.set(CreditStatus.TELEPHONE_INVESTIGATION, "Investigacion Telefonica");
    result.set(CreditStatus.HOME_DOMESTIC_INVESTIGATION, "Investigacion Domiciliaria Casa");
    result.set(CreditStatus.WORK_DOMESTIC_INVESTIGATION, "Investigacion Domiciliaria Trabajo");
    result.set(CreditStatus.HUMAN_RESOURCES, "Recursos Humanos");
    result.set(CreditStatus.ANALISYS_AND_APPROVAL, "Analisis y aprobacion");
    result.set(CreditStatus.WITH_REQUIREMENTS, "En Requerimiento");
    result.set(CreditStatus.APPROVED, "Aprobada");
    result.set(CreditStatus.REJECTED, "Rechazada");
    result.set(CreditStatus.REPROGRAMMING_IT, "En reprogramacion IT");
    result.set(CreditStatus.REPROGRAMMING_HOUSE_ID, "En reprogramación ID Casa");
    result.set(CreditStatus.REPROGRAMMING_WORK_ID, "En reprogramación ID Trabajo");
    return result;
  }

  getBadgeCreditProcessStatusMap(): Map<string, string> {
    let result = new Map<string, string>();
    result.set(CreditProcessStatus.PROCESSED, "Procesada");
    result.set(CreditProcessStatus.FAILED, "Falló");
    result.set(CreditProcessStatus.UNPROCESSED, "Pendiente de procesar");
    result.set(CreditProcessStatus.DRAFT, "En Borradores");
    result.set(CreditProcessStatus.PROCESSING, "En Proceso");
    return result;
  }

  getBadgeWarningValues() {
    return [
      CreditStatus.CONTROL_TABLE,
      CreditStatus.TELEPHONE_INVESTIGATION,
      CreditStatus.HOME_DOMESTIC_INVESTIGATION,
      CreditStatus.WORK_DOMESTIC_INVESTIGATION,
      CreditStatus.HUMAN_RESOURCES,
      CreditStatus.ANALISYS_AND_APPROVAL,
      CreditStatus.WITH_REQUIREMENTS,
      CreditStatus.REPROGRAMMING_IT,
      CreditStatus.REPROGRAMMING_HOUSE_ID,
      CreditStatus.REPROGRAMMING_WORK_ID,
      CreditProcessStatus.UNPROCESSED,
      CreditProcessStatus.PROCESSING
    ]
  }

  getBadgeDangerValues() {
    return [
      CreditStatus.REJECTED,
      CreditProcessStatus.FAILED,
    ]
  }

  getBadgeSecondaryValues() {
    return [
      CreditStatus.NO_STATUS,
      CreditProcessStatus.DRAFT,
    ]
  }
}
